import React from 'react';
import { Box, LinearProgress } from '@material-ui/core';
import { List, Pagination, Record, useListContext } from 'react-admin';
import DataGridCardCustom from '../UI/DataGridCard';
import AvatarCard from './AvatarCard';
import ActionList from './actions/';
import RightInfoDrawer from '../drawer/RightInfoDrawer';
import Filters from './filters/simpleListFilter';
import { useDispatch, useSelector } from 'react-redux';
import { selectAnc } from '../../redux/actions/ancs';
import { ancs } from '../../pages/paths';
import { AVATARS } from '../../providers/resources';

export interface EnabledColumns {
    processingCapacity: boolean;
    sludgeStorageVolume: boolean;
    totalUsefulVolume: boolean;
    currentState: boolean;
    model: boolean;
}

const ListPagination = (props: any) => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

interface Props {
    enabledColumns: EnabledColumns;
    toggleColumn: (column: string, enabled: boolean) => void;
}

const listProps = {
    resource: AVATARS,
    hasCreate: false,
    hasEdit: false,
    hasList: true,
    hasShow: false,
    basePath: ancs,
    sort: { field: 'creationDate', order: 'DESC' },
    perPage: 50,
    filter: {
        serialization_groups: [
            'read_meta',
            'read_mc',
            'read_simple_company',
            'read_avatar_current_node',
            'read_node',
            'avatar_files',
        ],
        'groupAvatars.alphaId': 'smartconnect:rikutec:ancs',
    },
};

const LoadingBar = () => {
    const { loading } = useListContext();
    return loading ? (
        <LinearProgress style={{ position: 'absolute', top: -10, left: 0, right: 0, zIndex: 1000 }} />
    ) : null;
};

const CardsView: React.FC<Props> = ({ enabledColumns, toggleColumn }) => {
    const dispatch = useDispatch();

    // Selected row state from Redux to control the right-side info panel
    const selected: any = useSelector((state: any) => state?.rikutec?.ancs?.selected || {});
    const panelOpen = selected && Object.keys(selected).length > 0;
    const handleClosePanel = () => dispatch(selectAnc({}));

    const dataGridProps = {
        rowClick: (id: string, basePath: string, record: Record) => {
            dispatch(selectAnc(record));
            return null;
        },
        toFindSelected: {
            resource: 'ancs',
            key: 'selected',
        },
        hasBulkActions: null,
    };

    return (
        <Box className='list'>
            <List
                component='div'
                {...listProps}
                pagination={<ListPagination />}
                filters={<Filters />}
                actions={<ActionList toggleColumn={toggleColumn} enabledColumns={enabledColumns} viewMode={'cards'} />}
                bulkActionButtons={false}
                empty={false}
            >
                <Box
                    style={{
                        display: 'relative',
                    }}
                >
                    <LoadingBar />

                    <DataGridCardCustom {...dataGridProps} CardComponent={AvatarCard} />

                    {panelOpen && <RightInfoDrawer open={panelOpen} onClose={handleClosePanel} selected={selected} />}
                </Box>
            </List>
        </Box>
    );
};

export default CardsView;
